var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"invalid-x",attrs:{"width":"8","height":"8","viewBox":"0 0 8 8"}},[_c('path',{attrs:{"d":"M6.293 7.707a1 1 0 0 0 1.414-1.414l-6-6A1 1 0 1 0 .293 1.707l6 6zm-6-1.414a1 1 0 1 0 1.414 1.414l6-6A1 1 0 0 0 6.293.293l-6 6z","fill-rule":"nonzero"}})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/shared/components/InvalidCross.vue?vue&type=template&id=6e6b10f1&
// module id = null
// module chunks = 